/**
 * Falha de regra de negócio.
 *
 * Deliberadamente **não** estende `Error`: é um valor devolvido por `Result`, não algo
 * lançado. Carrega um código estável, usado na mensagem ao usuário, no teste e no log.
 */
export class DomainError {
  readonly code: string;
  readonly message: string;
  readonly details: Readonly<Record<string, unknown>> | undefined;

  constructor(code: string, message: string, details?: Record<string, unknown>) {
    this.code = code;
    this.message = message;
    this.details = details;
  }

  toString(): string {
    return `${this.code}: ${this.message}`;
  }
}

export function domainError(
  code: string,
  message: string,
  details?: Record<string, unknown>,
): DomainError {
  return new DomainError(code, message, details);
}

/** Códigos do domínio compartilhado. Códigos por módulo ficam junto do respectivo módulo. */
export const SHARED_ERROR = {
  INVALID_HOURS: 'SHARED.INVALID_HOURS',
  INVALID_MONEY: 'SHARED.INVALID_MONEY',
  INVALID_DATE: 'SHARED.INVALID_DATE',
  INVALID_WEEK: 'SHARED.INVALID_WEEK',
  INVALID_RANGE: 'SHARED.INVALID_RANGE',
} as const;
